// src/components/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../utils/firebase';
import Logo from './Logo';
import { useAuth } from '../contexts/authContext';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../utils/firebase';
import ChatToggleButton from './ChatToggleButton';

const Header = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [userRole, setUserRole] = React.useState(null);

  React.useEffect(() => {
    const fetchRole = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role || 'user');
        }
      }
    };
    fetchRole();
  }, [user]);

  const handleDashboard = () => {
    if (userRole === 'admin') {
      navigate('/admin');
    } else if (userRole === 'host') {
      navigate('/home');
    } else if (userRole === 'team_captain' || userRole === 'team_member') {
      navigate('/team/dashboard');
    } else {
      // Default fallback
      navigate('/home');
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  const handleHelpDesk = () => {
    if (userRole === 'admin') {
      navigate('/admin/support-tickets');
    } else {
      navigate('/helpdesk');
    }
  };

  const handleProfile = () => {
    if (userRole === 'admin') {
      // For admin users, go to account settings instead of profile
      navigate('/account-settings');
    } else if (userRole === 'team_captain' || userRole === 'team_member') {
      navigate('/team/profile');
    } else {
      navigate('/profile');
    }
  };

  return (
    <header className="bg-gray-900 border-b border-gray-800 shadow-lg mb-6">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center flex-shrink-0">
          <Logo size={48} className="logo-white" />
        </div>

        {/* Nav Links */}
        <nav className="flex space-x-6 text-sm font-medium">
          <button onClick={handleDashboard} className="text-green-200 hover:text-white transition-colors">Dashboard</button>
          
          {/* Admin-specific navigation */}
          {userRole === 'admin' && (
            <>
              <button onClick={() => navigate('/admin/moderation')} className="text-green-200 hover:text-white transition-colors">Moderation</button>
              <button onClick={() => navigate('/admin/marketplace')} className="text-green-200 hover:text-white transition-colors">Marketplace</button>
              <button onClick={() => navigate('/admin/ads')} className="text-green-200 hover:text-white transition-colors">Ads & Slides</button>
              <button onClick={() => navigate('/admin/analytics')} className="text-green-200 hover:text-white transition-colors">Analytics</button>
              <button onClick={() => navigate('/admin/security')} className="text-green-200 hover:text-white transition-colors">Security</button>
            </>
          )}
          
          {/* Creator Dashboard removed - all functionality moved to main dashboard */}
          
          <button onClick={handleProfile} className="text-green-200 hover:text-white transition-colors">
            {userRole === 'admin' ? 'Account Settings' : 'Profile'}
          </button>
          
          <button onClick={() => navigate('/faq')} className="text-green-200 hover:text-white transition-colors">FAQ</button>
          <button onClick={handleHelpDesk} className="text-green-200 hover:text-white transition-colors">Help Desk</button>
          <button onClick={handleLogout} className="text-red-400 hover:text-white transition-colors">Log Out</button>
        </nav>
      </div>
      <style>{`
        .logo-white {
          filter: brightness(0) invert(1) drop-shadow(0 0 16px #fff8);
          object-fit: contain;
          max-width: none;
          flex-shrink: 0;
        }
      `}</style>
      <ChatToggleButton />
    </header>
  );
};

export default Header;
